import {Grid} from "../Grid";
import {ColourPaletteSelection} from "./ColourPaletteSelection";
import {ColourPaletteValues} from "./ColourPaletteValues";

export const ColourPaletteForm = ({
                                      colours,
                                      setColours,
                                      selectedColours,
                                      setSelectedColours,
                                      name,
                                      setName,
                                      buttonText,
                                      submitColourPalette
                                  }
) => {
    return <div>
        <Grid numberOfColumns={2} gap={24}>
            <ColourPaletteSelection
                colours={colours}
                setColours={setColours}
                selectedColours={selectedColours}
                setSelectedColours={setSelectedColours}
            />

            <ColourPaletteValues
                colours={colours}
                setColours={setColours}
                selectedColours={selectedColours}
                setSelectedColours={setSelectedColours}
                name={name}
                setName={setName}
                buttonText={buttonText}
                submitColourPalette={() => submitColourPalette(name, selectedColours)}
            />
        </Grid>
    </div>
}